export default __webpack_public_path__ + "static/media/123.05fffa85.jpg";